import { render, staticRenderFns } from "./LabelSelect.vue?vue&type=template&id=e1fb350c&scoped=true"
import script from "./LabelSelect.vue?vue&type=script&lang=js"
export * from "./LabelSelect.vue?vue&type=script&lang=js"
import style0 from "./LabelSelect.vue?vue&type=style&index=0&id=e1fb350c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1fb350c",
  null
  
)

export default component.exports